// extracted by mini-css-extract-plugin
module.exports = {"Button":"controls_Button__YNnc3","Icon":"controls_Icon__H4JuS","isLightMode":"controls_isLightMode__AA9YU"};